import _ from 'lodash'

import ProductService from '@/services/retailer/ProductService.js'
import { build_query } from '@/utilities/helpers.js'

export const namespaced = true

export const state = {
  products: []
}
export const allowedFilters = ['name', 'id', 'subCategory.category_id', 'has_retailer_stock_input']
export const allowedSorts = ''
export const allowedIncludes = ''
export const allowedAppends = ''

export const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products
    state.meta = products.meta
  }
}

export const actions = {
  getProducts({ commit, state }, query) {
    const newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    return new Promise(resolve => {
      ProductService.getAllProducts(newQuery).then(response => {
        commit('SET_PRODUCTS', response)
        resolve(response)
      })
    })
  },
  searchProduct({ }, params) {
    const newQuery = build_query(params, allowedFilters)
    return new Promise(resolve => {
      ProductService.searchProduct(newQuery).then(response => {
        let categories = []
        let products = []
        _.each(response.data, product => {
          if (
            _.findIndex(categories, category => {
              return category.id === product.sub_category.category.id
            }) === -1
          ) {
            categories.push(product.sub_category.category)
          }
        })

        _.each(categories, category => {
          products.push({
            category: category.name,
            products: response.data.filter(product => {
              return product.sub_category.category.id === category.id
            })
          })
        })
        resolve(products)
      })
    })
  },
  getProductById({ }, productId) {
    return new Promise(resolve => {
      ProductService.getProductById(productId).then(response => {
        resolve(response.data)
      })
    })
  },
  getMobileProductsByCategory({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      ProductService.getMobileProductsByCategory(params.categoryId)
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
    })
  }
}
